import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputLabel, Radio, RadioGroup, Select, Switch, Tab, TextField, Typography } from '@mui/material';
import TextAreaComponents from '../../../components/TextAreaComponents/TextAreaComponents.tsx';
import { useSearchParams } from 'react-router-dom'
import AutoCompleteMultiSelect from '../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import CancelIcon from '@mui/icons-material/Cancel'
import galleryIcon from './../../../../assets/icons/gallery.png'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import checkImg from './../../../../assets/images/check.png'
import exclamationImg from './../../../../assets/images/exclamation.png'
import { uploadFiles } from './../../../../fileUploader/FileUploader'
import logo from './../../../../assets/icons/Go5050.png'
import info from './../../../../assets/icons/info2.png'
import location from './../../../../assets/icons/pin.png'
import upload from './../../../../assets/icons/upload.png'
import './EmployeeRegistration.css'
import { uploadOneFiles } from './../../../../fileUploader/SingleFileUploader.js'
import Backdrop from '@mui/material/Backdrop';

function EmployeeRegistrationForm(props) {
    const restaurantDatas = [
        { id: 1, title: ' Local Manager' },
        { id: 2, title: 'Waiter' },
        { id: 3, title: 'Super Admin' }
    ]
    const [searchParams, setSearchParams] = useSearchParams()

    const addValue = (props) => {
        console.log(props)
        // setAutoCompleteValue(props)
    }



    const [state, setState] = useState<ImageUploadState>({
        selectedImages: [],
    })

    const [filesData, setFilesData] = useState([]);

    const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files
        if (files) {

            const imagesArray: string[] = []
            const remainingSlots = 5 - state.selectedImages.length
            const filesToUpload = Array.from(files).slice(0, remainingSlots)
            console.log(filesToUpload);
            setFilesData(filesToUpload);
            event.target.value = '';
            for (let i = 0; i < filesToUpload.length; i++) {
                const file = filesToUpload[i]
                const reader = new FileReader()
                reader.onloadend = () => {
                    imagesArray.push(reader.result as string)
                    if (imagesArray.length === filesToUpload.length) {
                        const updatedImages = [...state.selectedImages, ...imagesArray]
                        setState({ selectedImages: updatedImages })
                    }
                }
                reader.readAsDataURL(file)
            }
        }
    }

    console.log(state.selectedImages)
    console.log(filesData)
    //image test start

    //image test end


    // const handleDeleteImage = (index: number) => {
    //     const updatedImages = [...state.selectedImages]
    //     updatedImages.splice(index, 1)
    //     setState({ selectedImages: updatedImages })
    // }
    const handleDeleteImage = () => {
        setState({ selectedImages: [] })
    }
    const [radioGetvalue, setradioGetvalue] = React.useState('');

    const handleradioGetvalueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setradioGetvalue((event.target as HTMLInputElement).value);
        console.log(radioGetvalue)
        // setgender((event.target as HTMLInputElement).value)


        // switch ((event.target as HTMLInputElement).value) {
        //     case "Item":
        //         setitemdata(itemdataTemp);
        //         break;
        //     case "Filter/ Sub filter":
        //         setitemdata(Sectiondata);
        //         break;
        //     case "Menu":
        //         setitemdata(MenuTypedata);
        //         break;
        //     case "All":
        //         setradioGetvalue((event.target as HTMLInputElement).value);
        //         break;
        // }
        // setitemdata();
    };



    //get api start
    const apiAddress = process.env.REACT_APP_SECRET;

    const [dataRows, setDataRows] = React.useState({ restaurantEmployeeRank: '', name: '', roleId: '', restaurantId: '' });

    const [isAlreadyUsed, setIsAlreadyUsed] = React.useState(true);
    const loadData = () => {
        axios
            .get(apiAddress + "/api/EmployeeRolerestaurant/" + searchParams.get('ri'))
            .then((response) => {
                console.log(response.data)
                setDataRows(response.data);
                console.log(dataRows);
                if (dataRows.length > 0) {
                    if (!response.data.isActive) {
                        setIsAlreadyUsed(false)
                    }
                }



            });
    }

    React.useEffect(() => {
        console.log('first')
        loadData();
    }, []);
    console.log(dataRows)
    // console.log(dataRows[0].name)   

    //get api end

    //form data start
    const [value, setValue] = React.useState<Dayjs | null>(dayjs('2022-04-17'));
    var month = parseInt(value.$M + 1)
    var day = value.$y + '-' + month + '-' + value.$D
    var mydate = new Date(day);

    console.log(mydate)



    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [joiningDate, setJoiningDate] = useState(mydate);
    const [gender, setGender] = useState(radioGetvalue);
    const [contactNumber, setContactNumber] = useState('');
    const [restaurant, setRestaurant] = useState(dataRows.restaurantId);
    const [role, setRole] = useState(dataRows.restaurantEmployeeRank);
    const [imageUrl, setImageUrl] = useState(state.selectedImages);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    //validtion state start
    const [firstNameError, setFirstNameError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);
    const [usernameError, setUsernameError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [contactNumberError, setContactNumberError] = useState(false);
    const [imageUrlError, setImageUrlError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    //validation state end


    console.log('Gender' + gender)
    //form data get end
    const [data, setData] = useState({
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        joiningDate: mydate,
        gender: radioGetvalue,
        contactNumber: '',
        restaurant: dataRows.restaurantId,
        role: dataRows.roleId,
        imageUrl: state.selectedImages[0],
        password: '',
        confirmPassword: ''
    });

    // useEffect(() => {
    //     setGender(radioGetvalue)
    //     setJoiningDate(mydate)
    //     setRestaurant(dataRows.restaurantId)
    //     setRole(dataRows.roleId)
    //     setImageUrl(state.selectedImages)
    //     setData({
    //         firstName,
    //         lastName,
    //         username,
    //         email,
    //         joiningDate,
    //         gender,
    //         contactNumber,
    //         restaurant,
    //         role,
    //         imageUrl,
    //         password,
    //         confirmPassword

    //     })
    // }, [
    //     firstName, lastName, username, email, contactNumber, password, confirmPassword
    // ])


    const firstnameFieldValue = (props) => {
        // data.firstName=props
        setFirstName(props)
        setFirstNameError(false);

    }

    const lastnameFieldValue = (props) => {
        //  data.lastName=props

        setLastName(props)
        setLastNameError(false)
    }
    const usernameFieldValue = (props) => {
        //    data.username=props  
        setUsername(props)
        setUsernameError(false)
    }

    const [isValidEmail, setIsValidEmail] = useState(false);
    const validateEmail = (props) => {

        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        setIsValidEmail(!emailPattern.test(props));
        return !emailPattern.test(props)
    };

    

   
    const emailFieldValue = (props) => {
        // data.email=props
        setEmail(props)
        setEmailError(false)
        validateEmail(email)
    }
    const [validPhoneNumber, SetvalidPhoneNumber] = useState(true);
    const contactFieldValue = (props) => {
        //  data.contactNumber=props
        console.log(props)
        try {
            var test = props / 1;
            console.log(isNaN(test));
            if (isNaN(test)) {
                console.log(props);
                var empty = props.slice(0, -1);
                console.log(empty);
                SetvalidPhoneNumber(false);
                setContactNumber(empty);
            }
            else {
                SetvalidPhoneNumber(true)
                setContactNumber(props)
            }
        }
        catch {
            console.log("Error");
        }

    }
    const passswordFieldValue = (props) => {
        //  data.password=props
        setPassword(props)
        setPasswordError(false)
    }
    const confirmpasswordFieldValue = (props) => {
        //  data.confirmpassword=props
        setConfirmPassword(props)
        setConfirmPasswordError(false)
    }
    const restaurantFieldValue = (props) => {
        //  data.restaurant=props
    }
    const roleFieldValue = (props) => {
        //  data.role=props
    }
    const textFieldValue = (props) => {

    }
    const [success, SetSuccess] = useState(false);
    const onSubmit = () => {
        var valid = true;
        if (firstName.trim() === '') {
            setFirstNameError(true);
            valid = false
        }
        if (lastName.trim() === '') {
            setLastNameError(true)
            valid = false
        }
        if (username.trim() === '') {
            setUsernameError(true)
            valid = false
        }
        if (email.trim() === '') {
            setEmailError(true)
            valid = false
        }
        if (!email.includes('@')) {
            valid = false;
            toast.error("Email validation Failed", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        if (contactNumber.trim() === '') {
            setContactNumberError(true)
            valid = false
        }
        if (contactNumber.length != 11) {
            valid = false;
            toast.error("Number can not be more than 11", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        if (password.trim() === '') {
            setPasswordError(true)
            valid = false
        }
        if (confirmPassword.trim() === '') {
            setConfirmPasswordError(true)
            valid = false
        }
        if (password != confirmPassword) {
            valid = false;
            toast.error("Password does not match", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        if (data.imageUrl == 0) {
            valid = false;
            toast.error("Please upload an image", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        data.imageUrl = state.selectedImages[0]
        console.log(state.selectedImages[0]);
        if (valid) {
            axios({
                method: 'post',
                url: apiAddress + '/api/Employee?id=' + searchParams.get('ri'),
                data: data
            })
                .then((response) => {
                    console.log(response)
                    toast.success("Successfully Saved", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    SetSuccess(true)
                })
                .catch((error) => {
                    console.log(error);
                    toast.error(error.response.data.status, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                });
        }
        // axios.post(apiAddress + "/api/Employee", data)

    }

    const uploadImg = () => {
        console.log(filesData);

        uploadFiles(filesData);



    }
    const [selectedGender, setSelectedGender] = useState('');

    const handleGenderChange = (event) => {
        // event.preventDefault()
       
        setSelectedGender(event.target.value);
    };
    const [selectedDate, setSelectedDate] = useState('');

    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };
    var date = new Date(selectedDate);
    console.log(date)
    const [obj, setObj] = useState({
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        joiningDate: date,
        gender: selectedGender,
        contactNumber: '',
        restaurant: dataRows.restaurantId,
        role: dataRows.roleId,
        imageUrl: 'image',
        password: '',
        confirmPassword: ''
    });
    const [selectedFile, setSelectedFile] = useState()
    const handleImage = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault()
        var file = event.target.files[0]
        setSelectedFile(file)

    }
    console.log(selectedFile)
    const FileUploader = async (image) => {

        try {
            const resUrl = await uploadOneFiles(image);
            console.log(resUrl)

            return resUrl[0];
        } catch (err) {
            console.log(err);
            throw err;
        }

    }


    const handleContactNumber = (e) => {
        var num = e.target.value
        console.log(num)
        setContactNumber(num)
        if (num.length != 10 &&num.length != 11) {
            setContactNumberError(true)
        }
        else {
            setContactNumberError(false)

        }
    }

    const ErrorToast=(msg)=>{
        toast.error(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }
    async function handleSubmit() {

        var valid = true;
        var url = await FileUploader(selectedFile)
        console.log(url)
        obj.firstName = firstName
        obj.lastName = lastName
        obj.username = username
        obj.email = email
        obj.joiningDate = date
        obj.gender = selectedGender
        obj.contactNumber = contactNumber
        obj.restaurant = dataRows.restaurantId
        obj.role = dataRows.roleId
        obj.imageUrl = url
        obj.password = password
        obj.confirmPassword = confirmPassword
        console.log(obj.lastName)
        if (lastName == "" || username == "" || email == "" || contactNumber == ""
            || password == "" || confirmPassword == "" || selectedGender == "") {
            valid = false;
            ErrorToast("One or more filed is empty")
            
            
        }
        else{
            if(validateEmail(email)){
                valid=false
                ErrorToast("Email not valid")
            }
        }

        if (contactNumber.length != 10 &&contactNumber.length != 11) {
            valid = false;
            ErrorToast("Number must be of 10 or 11 digits")
            
        }
        if (password != confirmPassword) {
            valid = false;
            ErrorToast("Password does not match")
            
        }
        if (!!url==false) {
            valid = false;
            ErrorToast("Image not uploaded")
            
        }



        if (valid) {
            console.log(obj)
            axios({
                method: 'post',
                url: apiAddress + '/api/Employee?id=' + searchParams.get('ri'),
                data: obj
            })
                .then((response) => {
                    console.log(response)
                    toast.success("Successfully Saved", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    SetSuccess(true)
                })
                .catch((error) => {
                    console.log(error);
                    toast.error(error.response.data.status, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                });
        }
    }
    // const onTest=async()=>{

    //     var url= await FileUploader(selectedFile)
    //    console.log(url)
    //     obj.firstName=firstName
    //     obj.lastName=lastName
    //     obj.username=username
    //     obj.email=email
    //     obj.joiningDate=date
    //     obj.gender=selectedGender
    //     obj.contactNumber=contactNumber
    //     obj.restaurant= dataRows.restaurantId
    //     obj.role= dataRows.roleId
    //     obj.imageUrl=url
    //     obj.password=password
    //     obj.confirmPassword=confirmPassword
    //     console.log(obj)
    // }

    const [isAgreementChecked, setIsAgreementChecked] = useState(false);

    // Function to handle checkbox change
    const handleAgreementCheckboxChange = (event) => {
        setIsAgreementChecked(event.target.checked);
    };

    const [open, setOpen] = React.useState(false);


    //   useEffect(()=>{
    //     setOpen(props.open)
    //   })


    const handleClose = () => {
        // if (reason && reason == "backdropClick") 
        //     return;
        setOpen(false);
        props.modalClose(open)

    }

    const today = new Date().toISOString().split('T')[0];
    const [maxDate, setMaxDate] = useState(today);

    return (
        // <div className='p-5 '>
        //     <ToastContainer />

        //     {
        //         isAlreadyUsed ? (
        //             success ? (
        //                 <div style={{ height: "100vh" }}>
        //                     <div className={`h-100`} >
        //                         <div className='d-flex align-items-center justify-content-center h-100' style={{ flexDirection: "column" }}>
        //                             <img src={checkImg} alt="" style={{ width: "5rem" }} />
        //                             <h2>Account creation successfully</h2>
        //                             <p className='text-center'>Please check your email to verify.</p>
        //                         </div>
        //                     </div>
        //                 </div>
        //             ) : (
        //                 <div className='p-3 kycform' style={{ padding: "10px" }}>
        //                     <div className='d-flex justify-content-center'>
        //                         <h3 className='headerName'>Employee Form</h3>
        //                     </div>
        //                     <Grid container spacing={5} sx={{ padding: '0.5rem' }}>

        //                         <Grid item xs={6}>
        //                             <TextAreaComponents label={'First Name'} value={firstnameFieldValue} error={firstNameError} id={6}></TextAreaComponents>
        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             <TextAreaComponents label={'Last Name'} value={lastnameFieldValue} error={lastNameError} id={6}></TextAreaComponents>
        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             <TextAreaComponents label={'User Name'} value={usernameFieldValue} error={usernameError} id={6}></TextAreaComponents>
        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             <TextAreaComponents label={'Email Address'} value={emailFieldValue} isValid={isValidEmail} error={emailError} id={6}></TextAreaComponents>
        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             <LocalizationProvider dateAdapter={AdapterDayjs} sx={{ width: '100%' }}>
        //                                 <DemoContainer components={['DatePicker']} sx={{ width: '100%' }}>
        //                                     <DatePicker label="Date Of Birth" sx={{ width: '100%' }} onChange={(newValue) => setValue(newValue)} className='custom-textField custom-DateField' />
        //                                 </DemoContainer>
        //                             </LocalizationProvider>
        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             {/* <TextAreaComponents label={'Gender'} value={textFieldValue} id={5}></TextAreaComponents> */}
        //                             <Grid container style={{ paddingTop: '1rem' }}>
        //                                 <Grid xs={2} >
        //                                     <Typography >
        //                                         Gender
        //                                     </Typography>
        //                                 </Grid>
        //                                 <Grid xs={9}>
        //                                     <RadioGroup
        //                                         row
        //                                         aria-labelledby="demo-row-radio-buttons-group-label"
        //                                         name="row-radio-buttons-group"
        //                                         value={radioGetvalue}
        //                                         onChange={handleradioGetvalueChange}
        //                                     >
        //                                         <FormControlLabel value="Male" control={<Radio />} label="Male" />
        //                                         <FormControlLabel value="Female" control={<Radio />} label="Female" />
        //                                         {/* <FormControlLabel value="All" control={<Radio />} label="All" /> */}
        //                                     </RadioGroup>
        //                                 </Grid>
        //                             </Grid>
        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             <TextAreaComponents label={'Contact Number'} value={(props) => { setContactNumber(props); setContactNumberError(false) }} error={contactNumberError} id={13} val={contactNumber}></TextAreaComponents>
        //                             <span className={`${validPhoneNumber ? "d-none" : ""}`} style={{ color: "red" }}>Contact Number is not valid</span>
        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             <TextAreaComponents label={'Select Restaurant'} value={restaurantFieldValue} val={dataRows.name} id={6}></TextAreaComponents>

        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             <TextAreaComponents label={'Role'} value={roleFieldValue} val={dataRows.restaurantEmployeeRank} id={6}></TextAreaComponents>
        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             <Grid container spacing={2}>
        //                                 <Grid item xs={2}>
        //                                     <Button
        //                                         variant="contained"
        //                                         component="label"
        //                                         style={{ backgroundColor: 'white', color: 'gray' }}
        //                                     >
        //                                         <img
        //                                             src={galleryIcon}
        //                                             alt="photo"
        //                                             style={{ width: '2rem' }}
        //                                         />
        //                                         Upload
        //                                         <input
        //                                             hidden
        //                                             // accept="image/*"
        //                                             multiple
        //                                             type="file"
        //                                             onChange={handleImageUpload}
        //                                             disabled={state.selectedImages.length === 1}
        //                                         />
        //                                     </Button>
        //                                 </Grid>
        //                                 {state.selectedImages.map((image, index) => (
        //                                     <Grid item xs={2} sm={2} md={2} key={index}>
        //                                         <div
        //                                             style={{
        //                                                 position: 'relative',
        //                                                 marginTop: "-20px"
        //                                             }}
        //                                         >
        //                                             <img
        //                                                 src={image}
        //                                                 alt={`Preview ${index + 1}`}
        //                                                 style={{
        //                                                     maxWidth: '100%',
        //                                                     maxHeight: '100%',
        //                                                     objectFit: 'cover',
        //                                                 }}
        //                                             />
        //                                             <IconButton
        //                                                 style={{
        //                                                     position: 'absolute',
        //                                                     top: '-25px',
        //                                                     right: '-23px',
        //                                                     color: 'gray',
        //                                                 }}
        //                                                 onClick={() => handleDeleteImage(index)}
        //                                             >
        //                                                 <CancelIcon />
        //                                             </IconButton>
        //                                         </div>
        //                                     </Grid>
        //                                 ))}

        //                             </Grid>

        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             <div className='d-flex' style={{ gap: "10px" }}>
        //                                 <TextAreaComponents label={'Password'} value={passswordFieldValue} error={passwordError} id={6}></TextAreaComponents>

        //                             </div>

        //                         </Grid>
        //                         <Grid item xs={6}>
        //                             <div className='d-flex' style={{ gap: "10px" }}>
        //                                 <TextAreaComponents label={'Confirm Password'} value={confirmpasswordFieldValue} error={confirmPasswordError} id={6}></TextAreaComponents>

        //                             </div>

        //                         </Grid>
        //                     </Grid>

        //                     <Grid container sx={{ padding: '0.5rem' }}>

        //                         <Grid item xs={12}>
        //                             <div className='d-flex justify-content-end' onClick={onSubmit}>
        //                                 <Button className="" >Submit</Button>
        //                             </div>

        //                         </Grid>

        //                     </Grid>
        //                 </div>
        //             )

        //         ) : (
        //             <div style={{ height: "100vh" }}>
        //                 <div className={`h-100`} >
        //                     <div className='d-flex align-items-center justify-content-center h-100' style={{ flexDirection: "column" }}>
        //                         <img src={exclamationImg} alt="" style={{ width: "5rem" }} />
        //                         <h2>Link Already used</h2>
        //                     </div>
        //                 </div>
        //             </div>
        //         )

        //     }

        // </div>


        <>

            <Dialog

                maxWidth='lg'
                open={props.open}
                // open={true}
            
                onClose={handleClose}


            >

                <DialogContent>
                    
                    <div className='d-flex justify-content-between LogoLoginDiv'>
                        <div className='logo'>
                            <img src={logo} alt='logo' style={{ width: '2.5rem', height: '2rem' }} />
                        </div>
                        <p>Login</p>
                    </div>

                    <div className='formPadding'>
                        <div className='d-flex justify-content-center'>
                            <h2>Register</h2>
                        </div>
                        <p>Join our community of savers!</p>
                        <hr />
                        {/* <form onSubmit={handleSubmit}> */}
                        <div className='d-flex justify-content-between'>
                            <div className='formFieldWidth'>
                                <label className='form-label'>First name</label>
                                <input className="form-control " type="text" aria-label="default input example" style={{ width: '100%' }} value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
                            </div>
                            <div className='formFieldWidth'>
                                <label className='form-label'>Last name</label>
                                <input className="form-control " type="text" aria-label="default input example" style={{ width: '100%' }} value={lastName} onChange={(e) => setLastName(e.target.value)} required />
                            </div>
                        </div>

                        <div className='d-flex justify-content-between mt-3'>
                            <div className='formFieldWidth'>
                                <label className='form-label'>Username</label>
                                <input className="form-control " type="text" aria-label="default input example" style={{ width: '100%' }} value={username} onChange={(e) => setUsername(e.target.value)} required />
                            </div>
                            <div className='formFieldWidth'>
                                <label className='form-label'>Date of birth</label>
                                <input className="form-control " type="date"  aria-label="default input example" style={{ width: '100%' }} value={selectedDate}
                                  max={maxDate}  onChange={handleDateChange} />
                            </div>
                        </div>


                        <div className='d-flex justify-content-between mt-3'>
                            <div className='formFieldWidth'>
                                <label className='form-label'>Contact number</label>
                                <input className="form-control " type="number" aria-label="default input example" style={{ width: '100%' }} value={contactNumber} onChange={handleContactNumber} required />
                                {contactNumberError &&
                                    <span style={{ color: 'red' }}>Number must be of 10 or 11 digits</span>
                                }
                            </div>
                            <div className='formFieldWidth'>
                                <label className='form-label'>Gender</label>
                                <div className="form-check">
                                    <div className='d-flex justify-content-between'>
                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="male" value="male" onChange={handleGenderChange} />
                                        <label className="form-check-label" htmlFor="male">
                                            Male
                                        </label>
                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="female" value="female" onChange={handleGenderChange} />
                                        <label className="form-check-label" htmlFor="female">
                                            Female
                                        </label>
                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="others" value="others" onChange={handleGenderChange} />
                                        <label className="form-check-label" htmlFor="others">
                                            Others
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mb-3 mt-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Email address</label>
                            <input type="email" className="form-control" id="exampleFormControlInput1" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        </div>



                        <div className='d-flex justify-content-between mt-3'>
                            <div className='formFieldWidth'>
                                <label className='form-label'>Password</label>
                                <input className="form-control " type="password" aria-label="default input example" style={{ width: '100%' }} value={password} onChange={(e) => setPassword(e.target.value)} required />
                            </div>
                            <div className='formFieldWidth'>
                                <label className='form-label'>Confirm password</label>
                                <input className="form-control " type="password" aria-label="default input example" style={{ width: '100%' }} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                            </div>
                        </div>

                        <div className='ImageTitle mt-2'>
                        <p>Image</p>
                        </div>
                        <div className='btn  mt-2 RegisteruploadButton'>
                            <input type="file" className='' id="img" accept='.img, .jpg, .jpeg, .png' onChange={handleImage}></input>
                            <img src={upload} alt='' />
                            <label htmlFor="img">Upload</label>
                        </div>
                        {selectedFile &&

                            <p>{selectedFile.name}</p>

                        }
                        {/* <p className='pt-2'>Location</p> */}
                        <div className='locationDiv mt-3'>
                            <div className='locationDivTitle'>
                                <img src={info} alt='info' style={{ width: '2rem', height: '2rem' }} />
                                <label>Why we need your location</label>
                            </div>
                            <p>Sometimes some deals can only be shared between local users and your
                                location ensures you are matched only with users in the region
                                to best enjoy your favored deal Any issue sharing your location,
                                email helpagoso5o.co UK.</p>

                        </div>
                        <div className="input-group mb-3 mt-2">
                            <button className="btn " type="button" style={{ marginRight: '5px', backgroundColor: '#78a8c4', color: 'white' }}>
                                <div className='d-flex align-items-center'>
                                    <img src={location} alt='locatiopn' style={{ width: '1rem', height: '1rem' }} />
                                    Get Location
                                </div>
                            </button>
                            <select className="form-select" id="inputGroupSelect03" aria-label="Example select with button addon" >
                                <option selected>Find your location</option>
                                <option value="1">London</option>
                                <option value="2">Manchester</option>
                                <option value="3">Liverpool</option>
                            </select>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                checked={isAgreementChecked}
                                onChange={handleAgreementCheckboxChange}
                            />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                I accept the <a href='#' style={{ textDecoration: 'none' }}>terms and conditions</a>
                            </label>
                        </div>
                        <button className='btn' style={{ backgroundColor: '#78a8c4', color: 'white' }} onClick={handleSubmit} disabled={!isAgreementChecked}> Register</button>
                        {/* </form> */}
                    </div>
                    <div className={`${success ? "successModal-background-blur" : ""}`}>
                        <div className={`${success ? "Successmodal custom-registerForm loginCardKYC" : " d-none"}`}>
                            <div className='d-flex align-items-center' style={{ flexDirection: "column", gap: "10px", width: "27rem" }}>
                                <img src={checkImg} alt="" style={{ width: "5rem" }} />
                                <h2>Successfully registered </h2>
                                <p>Please check your email to verify yourself</p>
                                <h6 style={{ cursor: "pointer" }} onClick={() => { window.location.href = "/login" }}>Go to login</h6>
                            </div>

                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleClose}>Close</Button> */}
                </DialogActions>
            </Dialog>






        </>
    );
}

export default EmployeeRegistrationForm;